import React, { useState } from "react";
import SimpleBar from "simplebar-react";
import { useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faTimes } from "@fortawesome/free-solid-svg-icons";

import { Nav, Badge, Image, Button, Navbar } from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import { Routes } from "../routes";

import ReactHero from "../assets/img/technologies/react-hero-logo.svg";
import agLogoDark from "../assets/img/auto-geni-logo-dark.svg";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";

import {
  BiWrench,
  BiPackage,
  BiGridAlt,
  BiIdCard,
  BiCar,
  BiDollarCircle,
} from "react-icons/bi";

export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const NavItem = (props) => {
    const {
      title,
      link,
      external,
      target,
      icon,
      image,
      badgeText,
      badgeBg = "secondary",
      badgeColor = "primary",
    } = props;
    const classNames = badgeText
      ? "d-flex justify-content-start align-items-center justify-content-between"
      : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon">{icon}</span> : null}
            {image ? (
              <Image
                src={image}
                width={20}
                height={20}
                className="sidebar-icon svg-icon"
              />
            ) : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge
              pill
              bg={badgeBg}
              text={badgeColor}
              className="badge-md notification-count ms-2"
            >
              {badgeText}
            </Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      {/* Mobile backdrop */}
      {show && (
        <div 
          className="sidebar-backdrop d-md-none"
          onClick={onCollapse}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1040
          }}
        />
      )}
      
      <Navbar
        expand={false}
        collapseOnSelect
        variant="dark"
        className="navbar-theme-primary px-4 d-md-none"
      >
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.Dashboard.path}>
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle
          as={Button}
          aria-controls="main-navbar"
          onClick={onCollapse}
        >
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>

      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar
          className={`collapse ${showClass} sidebar d-md-block bg-white`}
          style={{ zIndex: show ? 1050 : 'auto' }}
        >
          <div className="sidebar-inner pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image
                    src={ProfilePicture}
                    className="card-img-top rounded-circle border-white"
                  />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button
                    as={Link}
                    variant="secondary"
                    size="xs"
                    to={Routes.Signin.path}
                    className="text-light"
                  >
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />{" "}
                    Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link
                className="collapse-close d-md-none"
                onClick={onCollapse}
              >
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>

            <Nav className="flex-column pt-3 pt-md-0 ">
              <Image
                src={agLogoDark}
                style={{ height: 76, marginBottom: 30 }}
              />

              <NavItem
                title="Dashboard"
                link={Routes.Dashboard.path}
                icon={<BiGridAlt />}
              />

              <NavItem
                title="Jobs"
                link={Routes.Jobs.path}
                icon={<BiWrench />}
              />

              <NavItem
                title="Customers"
                link={Routes.Customers.path}
                icon={<BiCar />}
              />
              <NavItem
                title="Services & Prices"
                link={Routes.ServicesPrices.path}
                icon={<BiDollarCircle />}
              />

              <NavItem
                title="Inventory"
                link={Routes.Inventory.path}
                icon={<BiPackage />}
              />

              <NavItem
                title="Workers"
                link={Routes.Workers.path}
                className="nav-item"
                icon={<BiIdCard />}
              />

              <Button
                as={Link}
                size="sm"
                to={Routes.SubscriptionPayments.path}
                variant="outline-primary"
                className="upgrade-to-pro"
              >
                Upgrade
              </Button>
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
